export const REGISTERED_TRADEMARK = '®'
